import { NotificationId as Api } from '@tableau/api-internal-contract-js';
import { NotificationId as PL } from '../../gen-src/preslayer/Events';
import { PresLayerToEmbeddingApiConverter } from './PresLayerToEmbeddingApiConverter';
import { EventMappingRegistration, EventMappingRegistry, SharedEventMappingRegistryFactory } from './SharedEventMappingRegistryFactory';

export class EventMappingRegistryFactory {
  /**
   * Creates and populates a new EventMappingRegistry
   *
   * @returns {EventMappingRegistry}
   */
  public static createEventMappingRegistry(): EventMappingRegistry {
    const registry: EventMappingRegistry = SharedEventMappingRegistryFactory.createEventMappingRegistry();

    registry[PL.FirstVizSizeKnown] = new EventMappingRegistration(
      PL.FirstVizSizeKnown,
      Api.FirstVizSizeKnown,
      PresLayerToEmbeddingApiConverter.convertFirstVizSizeKnownEvent,
    );

    registry[PL.VizInteractive] = new EventMappingRegistration(
      PL.VizInteractive,
      Api.VizInteractive,
      PresLayerToEmbeddingApiConverter.convertEmbeddingBootstrap,
    );

    registry[PL.AskDataInteractive] = new EventMappingRegistration(
      PL.AskDataInteractive,
      Api.AskDataInteractive,
      PresLayerToEmbeddingApiConverter.emptyConversion,
    );

    registry[PL.CustomMarkContextMenu] = new EventMappingRegistration(
      PL.CustomMarkContextMenu,
      Api.CustomMarkContextMenuClicked,
      PresLayerToEmbeddingApiConverter.convertCustomMarkContextMenu,
    );

    registry[PL.WorkbookReadyToClose] = new EventMappingRegistration(
      PL.WorkbookReadyToClose,
      Api.WorkbookReadyToClose,
      PresLayerToEmbeddingApiConverter.emptyConversion,
    );

    registry[PL.WorkbookPublished] = new EventMappingRegistration(
      PL.WorkbookPublished,
      Api.WorkbookPublished,
      PresLayerToEmbeddingApiConverter.emptyConversion,
    );

    registry[PL.WorkbookPublishedAs] = new EventMappingRegistration(
      PL.WorkbookPublishedAs,
      Api.WorkbookPublishedAs,
      PresLayerToEmbeddingApiConverter.convertWorkbookPublishedAsEvent,
    );

    registry[PL.EditButtonClicked] = new EventMappingRegistration(
      PL.EditButtonClicked,
      Api.EditButtonClicked,
      PresLayerToEmbeddingApiConverter.emptyConversion,
    );

    registry[PL.EditInDesktopButtonClicked] = new EventMappingRegistration(
      PL.EditInDesktopButtonClicked,
      Api.EditInDesktopButtonClicked,
      PresLayerToEmbeddingApiConverter.emptyConversion,
    );

    registry[PL.ToolbarStateChanged] = new EventMappingRegistration(
      PL.ToolbarStateChanged,
      Api.ToolbarStateChanged,
      PresLayerToEmbeddingApiConverter.convertToolbarStateChanged,
    );

    registry[PL.UrlAction] = new EventMappingRegistration(
      PL.UrlAction,
      Api.UrlAction,
      PresLayerToEmbeddingApiConverter.convertUrlActionEvent,
    );

    registry[PL.TabSwitched] = new EventMappingRegistration(
      PL.TabSwitched,
      Api.TabSwitched,
      PresLayerToEmbeddingApiConverter.convertEmbeddingBootstrap,
    );

    registry[PL.CustomViewsLoaded] = new EventMappingRegistration(
      PL.CustomViewsLoaded,
      Api.CustomViewsLoaded,
      PresLayerToEmbeddingApiConverter.convertCustomViewInfo,
    );

    registry[PL.CustomViewRemoved] = new EventMappingRegistration(
      PL.CustomViewRemoved,
      Api.CustomViewRemoved,
      PresLayerToEmbeddingApiConverter.convertCustomViewInfo,
    );

    registry[PL.CustomViewSaved] = new EventMappingRegistration(
      PL.CustomViewSaved,
      Api.CustomViewSaved,
      PresLayerToEmbeddingApiConverter.convertCustomViewInfo,
    );

    registry[PL.CustomViewSetDefault] = new EventMappingRegistration(
      PL.CustomViewSetDefault,
      Api.CustomViewSetDefault,
      PresLayerToEmbeddingApiConverter.convertCustomViewInfo,
    );

    registry[PL.StoryPointSwitched] = new EventMappingRegistration(
      PL.StoryPointSwitched,
      Api.StoryPointSwitched,
      PresLayerToEmbeddingApiConverter.convertStoryPointSwitchEvent,
    );
    return registry;
  }
}
